import { transformLetterSpacingToStage, transformLineSpacingToStage } from '@/utils/transform-kit';
import type { ILayerProps, IMarkupLayerProps, IMarkupPoint } from '@/version-types';
import { normalizeMarkupLayerDasharray } from '../config';

export function getDefaultMarkupPoint() {
    return {
        url: '',
        type: '',
        offset: 2,
        width: 0,
        height: 0,
    } as IMarkupPoint;
}

type MarkupRuntime = NonNullable<ILayerProps['__runtime']> & {
    markupType?: IMarkupLayerProps['markupType'];
};

export const normalizeMarkupLayerForRuntime = (layer: ILayerProps) => {
    const data = layer.data as IMarkupLayerProps;
    normalizeMarkupLayerDasharray(layer);
    data.startPoint ||= getDefaultMarkupPoint();
    data.endPoint ||= getDefaultMarkupPoint();

    if (!layer.__runtime?.isInit) {
        const label = { ...data.label };
        label.letterSpacing = transformLetterSpacingToStage(label.letterSpacing, label.fontSize);
        label.lineSpacing = transformLineSpacingToStage(label.lineSpacing);
        data.label = label;
    }

    data.startPoint.offset ||= getDefaultMarkupPoint().offset;
    data.endPoint.offset ||= getDefaultMarkupPoint().offset;
    const runtime = layer.__runtime as MarkupRuntime | undefined;
    const nextRuntime: MarkupRuntime = {
        ...runtime,
        isInit: true,
        markupType: runtime?.markupType || data.markupType,
    };
    layer.__runtime = nextRuntime;

    return layer;
};
